import { render, staticRenderFns } from "./popdialog.vue?vue&type=template&id=15ec0e3d&scoped=true"
import script from "./popdialog.vue?vue&type=script&lang=js"
export * from "./popdialog.vue?vue&type=script&lang=js"
import style0 from "./popdialog.vue?vue&type=style&index=0&id=15ec0e3d&prod&lang=less&scoped=true"
import style1 from "./popdialog.vue?vue&type=style&index=1&id=15ec0e3d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ec0e3d",
  null
  
)

export default component.exports